import { useEffect, useState } from 'react';
import ApiService from '../../service/ApiService';
import { apiPaths } from '../../service/apiPaths';
import { jwtDecode } from 'jwt-decode';

const useProfile = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [userData, setUserData] = useState<any | undefined>([]);
  const [user,setUser] = useState<string>('')
  const [role,setRole] = useState<string>('')
  const [document,setDocument] = useState<any>()
  
  useEffect(() => {
      const token = localStorage.getItem('accessToken')
      if (token) {
          const decodedToken: any = jwtDecode(token);
          setUser(decodedToken.userId)
          setRole(decodedToken.role)
        }
    },[])
  useEffect(() => {
      fetchData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  } ,[user])

  const fetchData = async () => {
    setLoading(true)
    try {
      const result = await ApiService({
        method: 'GET',
        endpoint: user ? `${apiPaths.getAllEmployees}/${user}` : ``,
      });
      setUserData(result)
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally{
      setLoading(false)
    }
  };
    const fetchEmployeeData = async () => {
    setLoading(true)
    try {
      const result = await ApiService({
        method: 'GET',
        endpoint: user ? `${apiPaths.getAllEmployees}?userId=${user}` : ``,
      });
      setUserData(result[0])
      setDocument(result.data[0].documentProof[0])
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally{
      setLoading(false)
    }
  }
  const fetchCustomerSupportData = async () => {
    setLoading(true)
    try {
      const result = await ApiService({
        method: 'GET',
        endpoint: user ? `${apiPaths.getAllCustomerSupports}?userId=${user}` : ``,
      });
      setUserData(result.data[0])
      setDocument(result.data[0].documentProof[0])
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally{
      setLoading(false)
    }
  }
  const fetchServiceStationData = async () => {
    setLoading(true)
    try {
      const result = await ApiService({
        method: 'GET',
        endpoint: user ? `${apiPaths.getAllServiceStations}?userId=${user}` : ``,
      });
      setUserData(result?.data[0])
      setDocument(result?.data[0]?.documentProof[0])
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally{
      setLoading(false)
    }
  }
  return { userData , loading , role , document};
};

export default useProfile;
